module.exports = __webpack_public_path__ + "static/img/ghs.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ghs.png
// module id = 0Zs+
// module chunks = 2